import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Home/Blogs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Home/EnquireNowButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Home/HomeMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Home/ImageGalleryWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Home/PopularSug.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/pluswilla-25/BannerImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/pluswilla-25/LazyContactForm.tsx");
